import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

import { useAppDispatch } from "@/reduxHooks.ts";
import { closeModal } from "@/slices/modal-slice/modal-slice";
import { AnalyticsEvents } from "@/utils/analytics-events";
import { analyticsService } from "@/utils/analytics-service";

export const UnlockAppModal = () => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal isCentered isOpen={true} onClose={handleClose} size={"lg"}>
      <ModalOverlay />
      <ModalContent className="!py-4">
        <ModalHeader className="!font-normal !ml-4">
          Unlock Full Potential with Your Own Datasets!
        </ModalHeader>
        <ModalCloseButton className="!mr-0" />
        <ModalBody className="!px-4">
          Thank you for the great rating! To try Clootrack Neo with your own
          datasets and get more personalized insights, you will need to upgrade.
          Please contact our sales team to explore the available options.
        </ModalBody>
        <ModalFooter className="!px-6 mt-6 mb-3 gap-4 !flex !justify-end">
          <Button
            colorScheme="secondary"
            onClick={handleClose}
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            colorScheme="dark"
            onClick={() => {
              analyticsService.trackEvent(
                AnalyticsEvents.CONTACT_US.BANNER
              );
              window.open("https://clootrack.com/request-demo", "_blank");
              handleClose();
            }}
          >
            Contact Sales
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
